// extracted by mini-css-extract-plugin
export default {"container":"PageWrapper_container__oug5M"};